var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FieldType } from './types';
import { ConfirmValidator, EmailValidator, MaxSizeValidator, MinSizeValidator, NumberValidator, PasswordValidator, PhoneNumberValidator, SizeValidator, URLValidator } from './Validator/Validator';
// TODO: Add validation error message overwrites
var FieldBuilder = /** @class */ (function () {
    function FieldBuilder(type, initialValue, resetValue) {
        this._touched = false;
        this._validators = [];
        this.type = type;
        this.initialValue = initialValue;
        this.resetValue = resetValue;
    }
    FieldBuilder.prototype.build = function (key, defaults) {
        var _a, _b, _c, _d, _e;
        return {
            // key,
            type: this.type,
            initialValue: this.initialValue,
            resetValue: this.resetValue,
            touched: this._touched,
            required: (_a = this._required) !== null && _a !== void 0 ? _a : defaults.required,
            showErrors: (_b = this._showErrors) !== null && _b !== void 0 ? _b : defaults.showErrors,
            persistURL: (_c = this._persistURL) !== null && _c !== void 0 ? _c : defaults.persistURL,
            persistStore: (_d = this._persistStore) !== null && _d !== void 0 ? _d : defaults.persistStore,
            validators: this._validators,
            valueConverter: (_e = this._valueConverter) !== null && _e !== void 0 ? _e : defaults.valueConverter(this.type),
        };
    };
    FieldBuilder.prototype.touched = function () {
        this._touched = true;
        return this;
    };
    FieldBuilder.prototype.unTouched = function () {
        this._touched = false;
        return this;
    };
    FieldBuilder.prototype.required = function () {
        this._required = true;
        return this;
    };
    FieldBuilder.prototype.optional = function () {
        this._required = false;
        return this;
    };
    FieldBuilder.prototype.showErrors = function () {
        this._showErrors = true;
        return this;
    };
    FieldBuilder.prototype.hideErrors = function () {
        this._showErrors = false;
        return this;
    };
    FieldBuilder.prototype.persistURL = function () {
        this._persistURL = true;
        return this;
    };
    FieldBuilder.prototype.nonPersistURL = function () {
        this._persistURL = false;
        return this;
    };
    FieldBuilder.prototype.persistStore = function () {
        this._persistStore = true;
        return this;
    };
    FieldBuilder.prototype.nonPersistStore = function () {
        this._persistStore = false;
        return this;
    };
    FieldBuilder.prototype.valueConverter = function (valueConverter) {
        this._valueConverter = valueConverter;
        return this;
    };
    /**
     * Validations
     */
    FieldBuilder.prototype.min = function (min) {
        this._validators.push(new MinSizeValidator(min));
        return this;
    };
    FieldBuilder.prototype.max = function (max) {
        this._validators.push(new MaxSizeValidator(max));
        return this;
    };
    FieldBuilder.prototype.size = function (min, max) {
        this._validators.push(new SizeValidator(min, max));
        return this;
    };
    FieldBuilder.prototype.confirm = function (field) {
        this._validators.push(new ConfirmValidator(field));
        return this;
    };
    FieldBuilder.prototype.number = function () {
        this._validators.push(new NumberValidator());
        return this;
    };
    FieldBuilder.prototype.email = function () {
        this._validators.push(new EmailValidator());
        return this;
    };
    FieldBuilder.prototype.URL = function () {
        this._validators.push(new URLValidator());
        return this;
    };
    FieldBuilder.prototype.password = function () {
        this._validators.push(new PasswordValidator());
        return this;
    };
    FieldBuilder.prototype.phoneNumber = function () {
        this._validators.push(new PhoneNumberValidator());
        return this;
    };
    FieldBuilder.prototype.cValidations = function (validators) {
        var _a;
        (_a = this._validators).push.apply(_a, validators);
        return this;
    };
    return FieldBuilder;
}());
export { FieldBuilder };
var SelectFieldBuilder = /** @class */ (function (_super) {
    __extends(SelectFieldBuilder, _super);
    function SelectFieldBuilder(initialValue, values) {
        var _this = _super.call(this, FieldType.SELECT, initialValue, values[0]) || this;
        _this.values = values;
        return _this;
    }
    SelectFieldBuilder.prototype.build = function (key, defaults) {
        return __assign(__assign({}, _super.prototype.build.call(this, key, defaults)), { values: this.values });
    };
    return SelectFieldBuilder;
}(FieldBuilder));
export { SelectFieldBuilder };
export default FieldBuilder;
